import React from "react";
import { IMG } from "../lib/constants";

export default function Logo({ size = 44, className = "" }) {
    return (
        <span
            className={`inline-flex items-center justify-center rounded-full overflow-hidden bg-cream/95 shadow-sm border border-[#B98E4E]/40 ${className}`}
            style={{ width: size, height: size }}
            aria-label="Veeras Western Ghats logo"
        >
            <img
                src={IMG.logo}
                alt="Veeras Western Ghats"
                className="h-full w-full object-cover"
            />
        </span>
    );
}
